
import Model from './Model'

export default class AppliedTax extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    this.tax_id = attributes.tax_id || null // INT
    this.tax_name = attributes.tax_name // VARCHAR 255
    this.tax_percentage = parseFloat(attributes.tax_percentage ?? 0) // DECIMAL 8,2
    this.base_amount = parseFloat(attributes.base_amount ?? 0) // DECIMAL 8,4
    this.tax_amount = parseFloat(attributes.tax_amount ?? 0) // DECIMAL 8,4
  }
}
